// Drift: jobansøgninger fra mailen på Supabase (del af SupabaseApi – se supabase.ts). Reglerne ligger i
// 20261028880000_ansoegninger.sql (RLS, evner, Vault) og i edge-funktionen ansoegninger-hent (IMAP).
import { ApiFejl, type Api } from './api';
import { tjekOpsaetning, type AnsoegOpsaetningInput, type Ansoegning } from '../../core/ansoegning';
import type { SbKontekst } from './sbKatalog';

export class SbAnsoeg {
  constructor(private readonly c: SbKontekst) {}
  private async rpc<T>(navn: string, args: Record<string, unknown> = {}): Promise<T> {
    return (await this.c.k(this.c.sb.rpc(navn, { k: await this.c.kraevKlient(), ...args }))) as T;
  }
  private async kald<T>(handling: string, o?: AnsoegOpsaetningInput): Promise<T> {
    return this.c.funktion<T>('ansoegninger-hent', { handling, klient: await this.c.kraevKlient(), ...(o ?? {}) });
  }

  ansoegninger: Api['ansoegninger'] = async () => {
    const k = await this.c.kraevKlient();
    const r = await this.c.k(this.c.sb.from('ansoegninger').select('id, uid, mappe, navn, email, telefon, emne, tekst, modtaget, status, note, vedhaeftninger, profil_id')
      .eq('klient_id', k).order('modtaget', { ascending: false }).limit(1000));
    return r as Ansoegning[];
  };
  retAnsoegning: Api['retAnsoegning'] = async (id, r) => { await this.rpc('ret_ansoegning', { p_id: id, p: r }); this.c.skift(); };
  sletAnsoegning: Api['sletAnsoegning'] = async (id) => { await this.rpc('slet_ansoegning', { p_id: id }); this.c.skift(); };
  ansoegningFil: Api['ansoegningFil'] = async (sti, navn, download = false) => {
    const r = await this.c.k(this.c.sb.storage.from('ansoegninger').createSignedUrl(sti, 300, download ? { download: navn } : undefined));
    return (r as { signedUrl: string }).signedUrl;
  };
  hentAnsoegninger: Api['hentAnsoegninger'] = async () => { const r = await this.kald<{ nye: number; flere: boolean }>('hent'); this.c.skift(); return r; };

  ansoegOpsaetning: Api['ansoegOpsaetning'] = () => this.rpc('ansoeg_opsaetning');
  gemAnsoegOpsaetning: Api['gemAnsoegOpsaetning'] = async (o) => {
    const nu = await this.ansoegOpsaetning();
    const f = tjekOpsaetning(o, !!nu?.kodeGemt);
    if (Object.keys(f).length) throw new ApiFejl('Tjek de markerede felter.', f);
    await this.rpc('gem_ansoeg_opsaetning', { p: { ...o, server: o.server.trim().toLowerCase(), bruger: o.bruger.trim(), mappe: o.mappe.trim() } });
    this.c.skift();
  };
  fjernAnsoegOpsaetning: Api['fjernAnsoegOpsaetning'] = async () => { await this.rpc('fjern_ansoeg_opsaetning'); this.c.skift(); };
  testAnsoegForbindelse: Api['testAnsoegForbindelse'] = (o) => this.kald('test', o);
  ansoegMapper: Api['ansoegMapper'] = async (o) => (await this.kald<{ mapper: string[] }>('mapper', o)).mapper;
}
